__turbopack_context__.v({
  "botAvatar": "HCn48a_botAvatar",
  "botAvatarLarge": "HCn48a_botAvatarLarge",
  "botInfo": "HCn48a_botInfo",
  "botMessage": "HCn48a_botMessage",
  "botSvg": "HCn48a_botSvg",
  "chatBotInfo": "HCn48a_chatBotInfo",
  "chatContainer": "HCn48a_chatContainer",
  "chatHeader": "HCn48a_chatHeader",
  "chatInput": "HCn48a_chatInput",
  "conversationalForm": "HCn48a_conversationalForm",
  "inputArea": "HCn48a_inputArea",
  "message": "HCn48a_message",
  "messageAppear": "HCn48a_messageAppear",
  "messageContent": "HCn48a_messageContent",
  "messages": "HCn48a_messages",
  "sendButton": "HCn48a_sendButton",
  "sendConfirmButton": "HCn48a_sendConfirmButton",
  "slideInLeft": "HCn48a_slideInLeft",
  "slideInRight": "HCn48a_slideInRight",
  "socialLinks": "HCn48a_socialLinks",
  "spin": "HCn48a_spin",
  "spinner": "HCn48a_spinner",
  "suggestionBubble": "HCn48a_suggestionBubble",
  "suggestionButton": "HCn48a_suggestionButton",
  "suggestionOptions": "HCn48a_suggestionOptions",
  "typing": "HCn48a_typing",
  "typingIndicator": "HCn48a_typingIndicator",
  "userAvatar": "HCn48a_userAvatar",
  "userMessage": "HCn48a_userMessage",
});
